// import { useEffect, useState } from "react";



// export const useFileTypeValidator = (file, allowedExtensions = []) => {
//   const [validatedFile, setValidatedFile] = useState(null);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!file) {
//       setValidatedFile(null);
//       setError(null);
//       return;
//     }

//     const fileExtension = file.name.split(".").pop().toLowerCase();

//     if (allowedExtensions.includes(fileExtension)) {
//       setValidatedFile(file);
//       setError(null);
//     } else {
//       setValidatedFile(null);
//       setError(`File type .${fileExtension} is not allowed`);
//     }
//   }, [file, allowedExtensions]);

//   return { validatedFile, error };
// };
import { useEffect, useState } from "react";

export const useFileTypeValidator = (
  file,
  allowedExtensions = [],
  maxSize = null // in bytes
) => {
  const [validatedFile, setValidatedFile] = useState(null);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   if (!file) {
  //     setValidatedFile(null);
  //     setError(null);
  //     return;
  //   }
    
    useEffect(() => {
    if (!file || !file.name) {
      setValidatedFile(null);
      setError(null);
      return;
    }
    const fileExtension = file.name.split(".").pop().toLowerCase();

    // File extension validation
    if (allowedExtensions.length && !allowedExtensions.includes(fileExtension)) {
      setValidatedFile(null);
      setError(`File type .${fileExtension} is not allowed`);
      return;
    }

    // File size validation
    if (maxSize && file.size > maxSize) {
      const maxSizeMB = (maxSize / (1024 * 1024)).toFixed(2);
      setValidatedFile(null);
      setError(`File size exceeds ${maxSizeMB} MB`);
      return;
    }

    setValidatedFile(file);
    setError(null);
  }, [file, allowedExtensions, maxSize]);

  return { validatedFile, error };
};